module.exports = __webpack_public_path__ + "assets/img/s5-tab-1-9c230d04.png";